<div class="headline">
  <ng-content select="h1,h2,h3,h4,h5,h6"></ng-content>
</div>
<div class="content">
  <ng-content select="gallery"></ng-content>
</div>
<div class="description">
  <ng-content select="p"></ng-content>
</div>
